import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import StorefrontAPI from 'utilities/storefrontApi';
import { loadRecent } from 'utilities/storefrontRecentlyViewed';
import { CARD, brandPath, formatMoney } from './styles';

/**
 * "Recently viewed" rail — pulls the last 6 product ids the shopper
 * looked at on this brand from `storefrontRecentlyViewed` and
 * re-fetches each so we always have the current price + primary image.
 *
 * Optionally excludes one id (the product detail page passes its own
 * id so the current product doesn't show in its own rail).
 */
export default function RecentlyViewed({ brand, excludeId }) {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (!brand?._id) return undefined;
    const ids = loadRecent(brand._id).filter((id) => String(id) !== String(excludeId)).slice(0, 6);
    if (ids.length === 0) { setProducts([]); return undefined; }
    let cancelled = false;
    Promise.all(ids.map((id) =>
      StorefrontAPI.getProduct(brand._id, { _id: id }).catch(() => null)
    )).then((rows) => {
      if (cancelled) return;
      setProducts(rows.filter(Boolean));
    });
    return () => { cancelled = true; };
  }, [brand?._id, excludeId]);

  if (products.length === 0) return null;

  return (
    <div style={{ marginTop: 32 }}>
      <h2 style={{ fontSize: 18, margin: '0 0 12px' }}>Recently viewed</h2>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
        gap: 14,
      }}>
        {products.map((p) => {
          const img = p.images?.find((i) => i.is_primary) || p.images?.[0];
          return (
            <Link
              key={p._id}
              to={brandPath(brand, `/shop/${p.slug || p._id}`)}
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <div style={{ ...CARD, padding: 0, overflow: 'hidden' }}>
                <div style={{
                  aspectRatio: '1 / 1', background: '#f1f5f9',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  {img?.url ? (
                    <img src={img.url} alt={img.alt || p.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (
                    <div style={{ color: '#94a3b8', fontSize: 12 }}>No image</div>
                  )}
                </div>
                <div style={{ padding: 10 }}>
                  <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 2 }}>{p.name}</div>
                  <div style={{ fontSize: 12, color: '#475569' }}>{formatMoney(p.base_price, p.currency)}</div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
